import classNames from 'classnames'
import { TReplaceOptions } from 'legacy/lut/library/translation/models/replaceOptions'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { TranslationMode } from 'cng-common/features/translations/configs'
import { selectTranslationMode } from 'cng-common/features/translations/selectors'
import { TPopupHorizontal } from 'core-components/library/popup'
import { Tooltip } from 'core-components/library/tooltip'

import styles from './HintComponent.module.scss'

interface IProps {
  text: string
  className?: string
  tipStyle?: string
  iconWrapStyle?: string
  replaceParams?: TReplaceOptions[]
}

export const HintComponent = ({
  text,
  className,
  tipStyle,
  iconWrapStyle,
  replaceParams,
}: IProps) => {
  const translationMode = useSelector(selectTranslationMode)
  const isTranslationMode = translationMode === TranslationMode.Edit

  if (isTranslationMode) {
    return <Translation text={text} actionsInside replaceParams={replaceParams} />
  }

  return (
    <Tooltip
      className={className}
      inline
      horizontalStartPosition={TPopupHorizontal.Right}
      horizontalDirection={TPopupHorizontal.Right}
      tipContent={() => (
        <div className={classNames(styles.tipContent, tipStyle)}>
          <Translation text={text} actionsInside replaceParams={replaceParams} />
        </div>
      )}
    >
      <div className={classNames(styles.iconWrap, iconWrapStyle)}>
        <i className={classNames('kbase kbase-info', styles.icon)} aria-hidden="true" />
      </div>
    </Tooltip>
  )
}
